/**
 * Wrapper for window.location changes, literally only exists to aid with tests
 */
export const navigateTo = (location: string) => {
  window.location.assign(location);
};
